/* Khleopatra – funzioni extra del carrello laterale:
   timer prenotazione, codice sconto, contatore titolo, apertura nell'editor. */
(function () {
  if (window.__khcCartDrawerInit) return;
  window.__khcCartDrawerInit = true;

  var TIMER_KEY = 'khc_cart_timer_end';

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function store(get, val) {
    try {
      if (get) return localStorage.getItem(TIMER_KEY);
      if (val === null) localStorage.removeItem(TIMER_KEY);
      else localStorage.setItem(TIMER_KEY, String(val));
    } catch (e) { return null; }
  }

  /* ---------- Timer prenotazione ---------- */
  function tickTimers() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('is-empty')) { store(false, null); return; }

    var timers = document.querySelectorAll('[data-khc-timer]');
    if (!timers.length) return;

    var minutes = parseInt(timers[0].dataset.minutes, 10) || 10;
    var restart = timers[0].dataset.restart === 'true';
    var now = Date.now();
    var end = parseInt(store(true), 10);

    if (!end || isNaN(end) || end - now > minutes * 60000) {
      end = now + minutes * 60000;
      store(false, end);
    }

    var remaining = Math.round((end - now) / 1000);
    if (remaining <= 0 && restart) {
      end = now + minutes * 60000;
      store(false, end);
      remaining = minutes * 60;
    }

    timers.forEach(function (el) {
      if (remaining <= 0) {
        var expired = el.dataset.expiredText;
        if (!expired) { el.hidden = true; return; }
        var text = el.querySelector('.khc-timer__text');
        if (text && text.textContent !== expired) text.textContent = expired;
        return;
      }
      var time = el.querySelector('.khc-timer__time');
      var label = pad(Math.floor(remaining / 60)) + ':' + pad(remaining % 60);
      if (time && time.textContent !== label) time.textContent = label;
    });
  }
  setInterval(tickTimers, 1000);
  document.addEventListener('DOMContentLoaded', tickTimers);

  /* ---------- Contatore nel titolo (aggiornato anche dopo l'upsell) ---------- */
  function syncCount() {
    var items = document.querySelector('#CartDrawer cart-drawer-items');
    if (!items || items.dataset.cartCount === undefined) return;
    document.querySelectorAll('#CartDrawer .khc-count').forEach(function (el) {
      if (el.textContent !== items.dataset.cartCount) el.textContent = items.dataset.cartCount;
    });
  }
  function observe() {
    var root = document.getElementById('CartDrawer');
    if (!root || root.__khcObserved) return;
    root.__khcObserved = true;
    new MutationObserver(function () { syncCount(); tickTimers(); }).observe(root, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', observe);
  observe();

  /* ---------- Codice sconto ---------- */
  function renderSections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var html = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var src = html.querySelector('.drawer__inner');
      var dest = document.querySelector('#CartDrawer .drawer__inner');
      if (src && dest) dest.innerHTML = src.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleHtml = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && bubbleHtml) bubble.innerHTML = bubbleHtml.innerHTML;
    }
  }

  function updateDiscounts(codes) {
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); });
  }

  function showError(message) {
    var el = document.querySelector('#CartDrawer .khc-discount__error');
    if (el) el.textContent = message || '';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-khc-discount]');
    if (!form) return;
    event.preventDefault();

    var input = form.querySelector('input[name="discount"]');
    var button = form.querySelector('button');
    var code = (input.value || '').trim();
    var errorText = form.dataset.error || '';
    if (!code) return;

    var existing = (form.dataset.codes || '').split(',').filter(Boolean);
    if (existing.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { input.value = ''; return; }

    button.setAttribute('aria-busy', 'true');
    showError('');

    updateDiscounts(existing.concat(code))
      .then(function (cart) {
        var match = (cart.discount_codes || []).find(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        });
        if (!match || !match.applicable) {
          return updateDiscounts(existing).then(function (restored) {
            renderSections(restored.sections);
            showError(errorText);
          });
        }
        renderSections(cart.sections);
      })
      .catch(function () { showError(errorText); })
      .finally(function () { button.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-khc-remove-code]');
    if (!btn) return;
    event.preventDefault();
    var form = document.querySelector('#CartDrawer [data-khc-discount]');
    var remove = btn.dataset.khcRemoveCode.toLowerCase();
    var remaining = ((form && form.dataset.codes) || '').split(',').filter(function (c) {
      return c && c.toLowerCase() !== remove;
    });
    btn.disabled = true;
    updateDiscounts(remaining).then(function (cart) { renderSections(cart.sections); });
  });

  /* ---------- Editor del tema: apri il carrello quando selezioni la sezione ---------- */
  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.id === 'shopify-section-cart-drawer') {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.open) drawer.open();
    }
  });
  document.addEventListener('shopify:section:load', function () { observe(); tickTimers(); });
})();
